import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-having-type',
    templateUrl: './having-type.component.html',
    styleUrls: ['./having-type.component.css']
})
export class HavingTypeComponent implements OnInit {

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/having-type/having-type.component.ts